import React from "react";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import { ErrorMessage, RequiredMark } from "@components/inputs/shared";
import { TextareaFieldProps } from "./types";

const TextareaFieldTemplate = (props: TextareaFieldProps) => {
	const { t } = useTranslation();

	const {
		label,
		name,
		className,
		errorMessage,
		type = "text",
		required = false,
		cols,
		rows,
		maxLength,
		placeholder,
		asterisksClass,
		...rest
	} = props;

	const { register } = useFormContext();

	const field = register(name, {
		required: {
			value: required,
			message: errorMessage || "COMMON.REQUIRED_FIELD",
		},
	});

	return (
		<div className={className ? className : "col col-sml-12 form__field"}>
			<label htmlFor={name} className="label">
				{t(label)}
				<RequiredMark
					required={required}
					asterisksClass={asterisksClass}
				/>
			</label>
			<ErrorMessage name={name} />
			<div className="form__field--textarea">
				<textarea
					id={name}
					className="form__field--textarea__input input input--textarea"
					placeholder={t(placeholder || "")}
					{...rest}
					{...field}
				/>
			</div>
		</div>
	);
};
export default TextareaFieldTemplate;
